import templateUploadLogo from './organizationUploadLogo.template.html';
import templateChangeOwner from './organizationChangeOwner.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $mdDialog,
  webpage,
  eventService,
  uiService,
  authenticationService,
  organizationService,
  accountsService,
  navigationService,
  changesService,
  jsonFactory,
  helperService,
  TimeUnit,
  OrganizationDetails,
  OrganizationEnterprise,
  GLOBAL,
  ACCOUNT,
  ORGANIZATION,
  GOOGLEMAPS,
  INSTANCE
) => {
  $scope.Model = {
    currentOrganizationIdOwner: '',
    changedOrganizationIdOwner: '',
    organizationCountry: '',
    availableAccounts: null,
    countries: null,
    currencies: null,
    timeZones: null,
    timeUnits: null,
    theme: '',
    themes: null,
    googleAutocompleteOptions: {},
    availableStates: [],
    availableStreetTypes: [],
    searchStreetTypeTerm: '',
    isReady: false,
    INSTANCE
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    $q.all([
      organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
      accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS }),
      jsonFactory.getCountries(),
      jsonFactory.getCurrencies(),
      jsonFactory.getZones()
    ])
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.organization = OrganizationDetails.build(
          data[0].organization
        );
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data[0].enterprise
        );

        // Set Model values
        $scope.Model = {
          currentOrganizationIdOwner: data[0].idOwner,
          changedOrganizationIdOwner: data[0].idOwner,
          organizationCountry: helperService.getOrganizationCountry(),
          availableAccounts: data[1],
          countries: data[2],
          currencies: data[3],
          timeZones: _.filter(data[4].zones, (zone) =>
            $rootScope.CurrentOrganization.organization.address.countryCode
              ? zone.countryCodes.includes(
                  $rootScope.CurrentOrganization.organization.location.cca2
                )
              : true
          ),
          timeUnits: TimeUnit.Available,
          theme: $rootScope.CurrentOrganization.isRoot()
            ? $rootScope.CurrentOrganization.organization.theme
            : $rootScope.CurrentOrganization.organization.themeClient,
          themes: angular.copy(GLOBAL.THEMES.sort()),
          googleAutocompleteOptions: {
            componentRestrictions: GOOGLEMAPS.restrictToCountries
          },
          availableStates: helperService.getAvailableAddressStates(),
          availableStreetTypes: helperService.getAvailableAddressStreetTypes()
        };
        $scope.Model.themes.unshift('default');

        // Watch address fields for changes, this is necessary since model changes will not affect ng-change
        $scope.$watch(
          () => [$rootScope.CurrentOrganization.organization.address],
          (newValues, oldValues) => {
            if (
              newValues &&
              oldValues &&
              newValues[0] &&
              oldValues[0] &&
              (newValues[0].suiteNumber !== oldValues[0].suiteNumber ||
                newValues[0].streetNumber !== oldValues[0].streetNumber ||
                newValues[0].street !== oldValues[0].street ||
                newValues[0].streetType !== oldValues[0].streetType ||
                newValues[0].suburb !== oldValues[0].suburb ||
                newValues[0].city !== oldValues[0].city ||
                newValues[0].state !== oldValues[0].state ||
                newValues[0].postalCode !== oldValues[0].postalCode)
            ) {
              const pickedCountry = _.find($scope.Model.countries, (c) => {
                return (
                  c.cca2 === $rootScope.CurrentOrganization.organization.address.countryCode
                );
              });
              if (pickedCountry && pickedCountry.cca2 && pickedCountry.cca2 !== '') {
                $rootScope.CurrentOrganization.organization.location = pickedCountry;
              }
              $scope.toggleChanges('organization', 'address');
            }
          },
          true
        );
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Organization details : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.onBlur = () => {
    $rootScope.CurrentOrganization.organization.address.streetType =
      $scope.Model.searchStreetTypeTerm;
    $scope.toggleChanges('organization', 'address');
  };

  $scope.searchStreetTypes = () =>
    _.filter(
      $scope.Model.availableStreetTypes,
      (type) =>
        type?.value
          ?.toLowerCase()
          ?.indexOf($scope.Model.searchStreetTypeTerm?.toLowerCase()) !== -1
    );

  $scope.getThemeClass = (name) => {
    if (name === 'default') {
      return 'blue-500';
    }
    return name.replace('st-', '').replace('-h', '-');
  };

  $scope.getThemeName = (name) => {
    return name.replace('st', '').replace(/-/g, ' ').capitalizeFirstLetter();
  };

  $scope.toggleChanges = (group, field) => {
    changesService.change({ group, field });
  };

  $scope.uploadLogo = ($event) => {
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {},
        template: templateUploadLogo,
        controllerAs: '$ctrl',
        controller() {
          this.url = ORGANIZATION.API.UPLOAD;
          this.allowMultiple = ORGANIZATION.LIMITS.MULTIPLE;
          this.allowedMimeTypes = ORGANIZATION.LIMITS.ALLOWED_MIME;
          this.allowedExtensions = ORGANIZATION.LIMITS.ALLOWED_EXTENSIONS;
          this.minimumWidth = ORGANIZATION.LIMITS.MIN_WIDTH;
          this.minimumHeight = ORGANIZATION.LIMITS.MIN_HEIGHT;
          this.aspectRatio = ORGANIZATION.LIMITS.ASPECT_RATIO;
          this.cropType = ORGANIZATION.LIMITS.CROP_TYPE;
          this.uploadFinished = (logo) => {
            $mdDialog.hide(logo);
          };
          this.confirm = () => {
            this.startUpload = true;
          };
          this.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then(() => {
        $timeout(() => {
          if (
            $rootScope.CurrentOrganization.getLogo() !==
            `${INSTANCE.cdn}/logos/${$rootScope.CurrentOrganization.id}.png`
          ) {
            $rootScope.CurrentOrganization.organization.logo = `${INSTANCE.cdn}/logos/${$rootScope.CurrentOrganization.id}.png`;
          }
          $timeout(() => {
            $scope.toggleChanges('organization', 'logo');
            eventService.organizationLogoUploaded();
          }, 250);
          uiService.toast({
            text: {
              p1: 'Logo',
              p2: 'changed',
              p3: 'successfully'
            }
          });
        });
      });
  };

  $scope.changeOwner = ($event) => {
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          idOwnerNew: $scope.Model.changedOrganizationIdOwner,
          organizationName: $rootScope.CurrentOrganization.organization.name
        },
        template: templateChangeOwner,
        controllerAs: '$ctrl',
        controller(idOwnerNew, organizationName) {
          const self = this;
          self.organizationName = '';
          self.isOrganizationNameEqual = () =>
            self.organizationName.toLowerCase() === organizationName.toLowerCase();
          self.confirm = () => {
            $mdDialog.hide(idOwnerNew);
          };
          self.cancel = () => {
            $scope.Model.changedOrganizationIdOwner = $scope.Model.currentOrganizationIdOwner;
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        $rootScope.CurrentOrganization.idOwner = result;
        $scope.toggleChanges('owner', 'id');
      });
  };

  $scope.isOwner = () => authenticationService.isOwner();

  $scope.sampleDateFormat = () =>
    moment
      .tz($rootScope.CurrentOrganization.organization.timezone || 'UTC')
      .format($rootScope.CurrentOrganization.organization.dateFormat || 'LL');

  $scope.sampleTimeFormat = () =>
    moment
      .tz($rootScope.CurrentOrganization.organization.timezone || 'UTC')
      .format($rootScope.CurrentOrganization.organization.timeFormat || 'LTS');

  $scope.showWarning = () =>
    !$rootScope.CurrentOrganization?.organization?.name ||
    !$rootScope.CurrentOrganization?.organization?.currency ||
    !$rootScope.CurrentOrganization?.organization?.vat ||
    !$rootScope.CurrentOrganization?.organization?.timezone ||
    !$rootScope.CurrentOrganization?.organization?.dateFormat ||
    !$rootScope.CurrentOrganization?.organization?.timeFormat;

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const organizationData = { id: $rootScope.CurrentOrganization.id };
    if (changesService.hasChange({ group: 'organization' })) {
      // Address models are being set to undefined, we need to reset them to empty value
      _.forEach($rootScope.CurrentOrganization.organization.address, (val, prop) => {
        if ($rootScope.CurrentOrganization.organization.address[prop] === undefined) {
          $rootScope.CurrentOrganization.organization.address[prop] = '';
        }
      });
      organizationData.organization = $rootScope.CurrentOrganization.organization;
    }
    if (changesService.hasChange({ group: 'owner', field: 'id' })) {
      organizationData.idOwner = $rootScope.CurrentOrganization.idOwner;
    }
    if (!changesService.hasChange({ group: 'organization', field: 'logo' })) {
      if (
        organizationData &&
        organizationData.organization &&
        organizationData.organization.logo
      ) {
        delete organizationData.organization.logo;
      }
    }
    if (!changesService.hasChange({ group: 'organization', field: 'theme' })) {
      if (
        organizationData &&
        organizationData.organization &&
        organizationData.organization.theme
      ) {
        delete organizationData.organization.theme;
      }
    } else {
      organizationData.organization.theme = $scope.Model.theme;
    }
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        if (
          changesService.hasChange({ group: 'owner', field: 'id' }) &&
          $rootScope.CurrentOrganization.idOwner !== $scope.Model.currentOrganizationIdOwner
        ) {
          $state.transitionTo('authenticate');
        } else {
          navigationService.organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          });
        }
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
